"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTAccountsSumQueryParams = void 0;
const common_1 = require("@finley-technologies/common");
const formula_engine_1 = require("@finley-technologies/formula-engine");
const createTAccountsSumQueryParams = ({ postgresQuery, }) => {
    const { parameterConfig, variables } = postgresQuery;
    const { startDateFormula, endDateFormula, tAccountDetails } = parameterConfig;
    try {
        const dateResults = formula_engine_1.commonFormulas.evaluateStartAndEndDateFormulas({
            startFormula: startDateFormula.formula,
            endFormula: endDateFormula.formula,
            variables,
        });
        return {
            isValid: true,
            params: {
                startDate: dateResults.startDate,
                endDate: dateResults.endDate,
                tAccountDetails: tAccountDetails.accountDetails,
            },
        };
    }
    catch (err) {
        const errorMessage = `Detected error while creating TAccount Sum Query params [error:${(0, common_1.getErrorMessage)(err)}`;
        return {
            isValid: false,
            errors: [errorMessage],
        };
    }
};
exports.createTAccountsSumQueryParams = createTAccountsSumQueryParams;
//# sourceMappingURL=tAccountsSumQueryParams.js.map